module.exports = __webpack_public_path__ + "static/media/cover.f7532f76.png";